<script setup lang="ts">
const props = defineProps<{
    dimension?: Dimension
    highlight?: boolean
    showChildren?: boolean
}>()

/**
 * Use query params.
 */
const { config } = useParams()

/**
 * Use framework.
 */
const { findChildren } = useFramework()

/**
 * List of items.
 */
const items = computed(() => {
    if (!props.dimension?.id && !props.showChildren) return

    const id = props.showChildren
        ? props.dimension?.id
        : props.dimension?.parent

    return findChildren(id)
})

/**
 * List of options.
 */
const options = computed(() => {
    return unref(items)?.map(option => ({
        value: option.id,
        label: option.name
    }))
})

/**
 * Set the current dimension.
 */
function setDimension(value?: Dimension['id']) {
    config.dimension = value
}

/**
 * On click.
 */
function onClick() {
    if (!props.dimension?.id) {
        setDimension()
    }
}
</script>

<template>
    <UiSelect
        class="min-w-0 last:min-w-[20ch]"
        :options="options"
        @update:model-value="setDimension"
    >
        <template #activator>
            <ListboxButton
                :class="[highlight ? 'font-bold' : '']"
                class="bg-neutral border-deep-blue xl:screen-ratio-[2:1]:text-xs flex h-auto max-w-full cursor-pointer items-center gap-4 rounded-full border p-2 text-sm lg:w-auto lg:px-4 lg:py-1"
                @click="onClick"
            >
                <slot name="text" :text="dimension?.name">
                    <span class="min-w-0 truncate">
                        {{ dimension?.name }}
                    </span>
                </slot>

                <span
                    v-if="options"
                    class="pointer-events-none mx-auto hidden items-center lg:flex"
                >
                    <ChevronDownIcon
                        class="w-4 text-gray-400"
                        aria-hidden="true"
                    />
                </span>
            </ListboxButton>
        </template>
    </UiSelect>
</template>